import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const ValidationMessagesModal = ({ open, validations, handleConfirm, handleCancel, title = 'Validation Messages' }) => {
    const _handleConfirm = () => {
        handleConfirm && handleConfirm();
    };

    const _handleCancel = () => {
        handleCancel && handleCancel();
    };

    if (!validations) {
        return null;
    }

    return (
        <div>
            <Dialog
                open={open}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                {title && (
                    <div
                        className='page-header'
                        role='banner'
                    >
                        <h2
                            style={{
                                height: '50px',
                                marginTop: '15px',
                                marginLeft: '15px',
                            }}
                        >
                            {title}
                        </h2>
                    </div>
                )}
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        <div>
                            {validations.messages.map((m) => {
                                return (
                                    <div>
                                        {m.messageType === 0 ? (
                                            <span style={{ color: 'darkred' }}>
                                                <FontAwesomeIcon
                                                    icon={faExclamationTriangle}
                                                    style={{ color: 'darkred' }}
                                                />
                                                &nbsp;
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: m.message,
                                                    }}
                                                />
                                            </span>
                                        ) : (
                                            <span>
                                                <FontAwesomeIcon
                                                    icon={faExclamationTriangle}
                                                    style={{
                                                        color: 'darkorange',
                                                    }}
                                                />
                                                &nbsp;
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: m.message,
                                                    }}
                                                />
                                            </span>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div className='row'>
                        {!validations.hasErrors && (
                            <button
                                type='button'
                                className='button hollow'
                                onClick={_handleConfirm}
                                style={{ padding: '6px 12px' }}
                            >
                                Continue Anyway
                            </button>
                        )}
                        &nbsp;
                        <button
                            type='button'
                            className='button primary'
                            onClick={_handleCancel}
                            style={{ padding: '6px 12px' }}
                        >
                            Cancel
                        </button>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    );
};
